export default "__VITE_ASSET__DsYLANLO__"